import React, { memo } from 'react';
import { PackageIcon, UploadIcon } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'shadcn/components/ui/Card';
import { Separator } from 'shadcn/components/ui/Separator';

import { PurchaseOrderStatusCell } from '../../../procurement/components/purchaseOrdersV2/PurchaseOrderStatusCell';

import { DocumentsTable } from './DocumentsTable';

function PurchaseOrderDocumentsCard({ onUploadClick, poData }) {
    const detailItems = [
        { label: 'PO Type', value: poData.poType || 'N/A' },
        { label: 'Vendor', value: poData.vendorName || 'N/A' },
        { label: 'Facility', value: poData.facilityName || 'N/A' },
    ];

    return (
        <Card>
            <CardHeader>
                <div className="flex items-start justify-between">
                    <div className="space-y-1">
                        <div className="flex items-center gap-2">
                            <PackageIcon className="h-5 w-5 text-gray-500" />
                            <CardTitle>Purchase Order #{poData.id}</CardTitle>
                        </div>
                        <CardDescription>Purchase order details and documents</CardDescription>
                    </div>
                    <PurchaseOrderStatusCell status={poData.status} isCrossDock={false} isPriority={false} />
                </div>
            </CardHeader>

            <CardContent className="space-y-6">
                {/* PO Information Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {detailItems.map((item) => (
                        <div key={item.label}>
                            <p className="text-sm font-medium text-gray-500">{item.label}</p>
                            <p className="text-sm font-semibold mt-1">{item.value}</p>
                        </div>
                    ))}
                    <div className="flex items-end justify-end">
                        <Button onClick={onUploadClick} size="sm" className="gap-2">
                            <UploadIcon className="h-4 w-4" />
                            Upload Document
                        </Button>
                    </div>
                </div>

                <Separator />

                {/* Documents Table */}
                {poData?.id && <DocumentsTable poID={poData.id} />}
            </CardContent>
        </Card>
    );
}

const MemoizedPurchaseOrderDocumentsCard = memo(PurchaseOrderDocumentsCard);

export { MemoizedPurchaseOrderDocumentsCard as PurchaseOrderDocumentsCard };
